export default {
  title: '币种管理',

  // 搜索筛选区域
  search: {
    keyword: '关键词搜索',
    keywordPlaceholder: '币种代码、名称、符号',
    status: '状态',
    statusPlaceholder: '选择状态',
    enabled: '启用',
    disabled: '禁用',
    searchButton: '搜索',
    resetButton: '重置'
  },

  // 操作按钮
  actions: {
    selectFromLibrary: '新增币种',
    batchEnable: '批量启用',
    batchDisable: '批量禁用',
    enableItem: '启用',
    disableItem: '禁用',
    recordsCount: '共 {count} 条记录'
  },

  // 表格列
  table: {
    code: '币种代码',
    nameCn: '中文名称',
    nameEn: '英文名称',
    symbol: '符号',
    decimalPlaces: '币种小数位数',
    exchangeRateDecimalPlaces: '汇率小数位数',
    roundingRule: '进位规则',
    status: '状态',
    operation: '操作'
  },

  // 选择弹窗
  modal: {
    title: '选择币种',
    confirmText: '确认添加 ({count})',
    selected: '已选择 {count} 个币种，共 {total} 个可选'
  },

  // 确认对话框
  confirm: {
    enableItem: '确定要启用此币种吗？',
    disableItem: '确定要禁用此币种吗？',
    batchEnable: '确定要启用选中的 {count} 个币种吗？',
    batchDisable: '确定要禁用选中的 {count} 个币种吗？'
  },

  // 表单验证
  validation: {
    selectItems: '请选择要添加的币种'
  },

  // 消息提示
  messages: {
    selectToEnable: '请选择要启用的币种',
    selectToDisable: '请选择要禁用的币种',
    selectToAdd: '请选择要添加的币种',
    loadError: '币种数据加载失败，请稍后重试',
    platformLoadError: '平台币种数据加载失败，请稍后重试',
    searchError: '搜索失败，请稍后重试',
    associateError: '关联币种失败，请稍后重试',
    associateSuccess: '成功关联 {count} 个币种',
    statusToggleError: '状态切换失败，请稍后重试',
    statusToggleSuccess: '币种已{status}',
    batchEnableError: '批量启用失败，请稍后重试',
    batchEnableSuccess: '已启用 {count} 个币种',
    batchDisableError: '批量禁用失败，请稍后重试',
    batchDisableSuccess: '已禁用 {count} 个币种'
  },

  // 状态文本
  statusText: {
    enabled: '启用',
    disabled: '禁用'
  },

  // 进位规则
  roundingRules: {
    halfUp: '四舍五入',
    up: '向上进位',
    down: '向下进位'
  }
}